angular
    .module('control.searchDropdown')
    .directive("searchPolicyDropdown", ['$rootScope', '$filter', 'policySumm', 'policyService', 'commonConst', '$timeout', 'searchDropdownConst',
        function ($rootScope, $filter, policySumm, policyService, commonConst, $timeout, searchDropdownConst) {
            return {
                restrict: 'E',
                require: ['ngModel'],
                templateUrl: 'module/control/searchDropdown/search-policy-dropdown.html',
                scope: {
                    rowsPerPage: '=',
                    params: '=',
                    ngRequired: '=',
                    useClaimIfAvailable: '=',
                    ngModel: '=',
                    selectedData: '=',
                    placeholder: '@'
                },
                controller: function ($scope) {
                    if (angular.isUndefined($scope.placeholder)) {
                        $scope.placeholder = searchDropdownConst.POLICY_DROPDOWN_PLACEHOLDER;
                    }
                    if (angular.isUndefined($scope.params)) {
                        $scope.params = {};
                    }
                    if (angular.isUndefined($scope.rowsPerPage)) {
                        $scope.rowsPerPage = commonConst.ROWS_PER_PAGE;
                    }
                    $scope.noPolicyMessage = !!$scope.params.excludeInactivePolicy ?
                        searchDropdownConst.NO_ACTIVE_POLICY_MESSAGE :
                        searchDropdownConst.NO_POLICY_MESSAGE;
                    $scope.ngRequired = $filter('boolConverter')($scope.ngRequired);

                    (function onInit() {
                        policySumm.getPolicyCount($scope.rowsPerPage, 1, '', [], $scope.params.jurisdiction, $scope.params.excludeInactivePolicy).then(function (policyCount) {
                            $scope.policyCount = policyCount;

                            $scope.jurisdiction = $rootScope.getSelectedJurisdiction();
                            if($scope.params.jurisdiction !== undefined && $scope.params.jurisdiction !== null) {
                                $scope.jurisdiction = $scope.params.jurisdiction;
                            }
                            var recentlySelectedType = $filter('decstr64')(sessionStorage.RecentlySelectedType);
                            var useClaimIfAvailable = $filter('boolConverter')($scope.useClaimIfAvailable);
                            var policy = getPolicyFromSessionStorage(recentlySelectedType, $scope.jurisdiction, useClaimIfAvailable);
                           
                            // set modle to null if selected policy not belong to current dropdown jurisdiction
                            if(policy && $scope.jurisdiction && policy.Scheme !== $scope.jurisdiction) {
                                $scope.ngModel = null;
                            }

                            if (policyCount === 1) {
                                $scope.setSelectedData($rootScope.Policies.PolicyList[0], null, true);

                            } else if (policyCount > 1 && policyCount <= 10) {
                                policySumm.getPolicySummaryRecently(1, 10, '', $scope.jurisdiction, $scope.params.excludeInactivePolicy).then(function (data) {
                                    $scope.policyList = data.PolicyList.map(function (it) {
                                        return new PolicyModel(it);
                                    });

                                    var policyIndex = $scope.policyList.findIndex(function (it) {
                                        return (!!policy) ? (it.EmployerId === policy.EmployerId) : false;
                                    });
                                    if (!!policy &&
                                        ($scope.jurisdiction == null || policy.Scheme === $scope.jurisdiction) &&
                                        recentlySelectedType == commonConst.POLICY &&
                                        policyIndex > -1) {
                                        $scope.setSelectedData($scope.policyList[policyIndex], null, true);
                                    }
                                });

                            } else if (policyCount > 10) {
                                if (!!policy &&
                                    ($scope.jurisdiction == null || policy.Scheme === $scope.jurisdiction) &&
                                    recentlySelectedType === commonConst.POLICY &&

                                    (!$scope.params.excludeInactivePolicy || policy.StatusCode !== 'INACTIVE')) {
                                    $scope.setSelectedData(policy, null, true);
                                }
                            }
                        });
                    })(); // onInit

                    $scope.$on('setPolicySelection', function (event, policy) {
                        if($scope.ngModel !== policy.EmployerId) {
                            $scope.ngModel = policy.EmployerId;
                            $scope.selectedData = policy;
                            $timeout(function () {
                                var newOption = new Option(policy.text, policy.id, true, true);
                                if ($scope.policyCount > 10) {
                                    $('#policy-id').append(newOption);
                                } else {
                                    $('#policy-id').val(policy.id);
                                }
                                $('#policy-id').trigger('change');
                            });
                        }
                    }); // setPolicySelection

                    $scope.$on('resetPolicySelection', function (event) {
                        if ($scope.policyCount > 1) {
                            $scope.ngModel = null;
                            $scope.selectedData = null;
                            $timeout(function () {
                                // select2 accepts null as first option value, html select accepts empty
                                $("#policy-id").val($scope.policyCount > 10 ? '' : 'null').trigger("change");
                                $('#policy-id').data('kmselect2LastSearch', '');
                            });
                        }
                    }); // resetPolicySelection

                    $scope.setSelectedData = function (policy, callback, emitChange, childScope) {
                        if(!childScope) {
                            childScope = $scope;
                        }

                        if (!policy || !policy.EmployerId 
                                || ($scope.jurisdiction != null && policy.Scheme != $scope.jurisdiction)) {
                            childScope.ngModel = null;
                            childScope.selectedData = null;
                            $scope.selectedData = null;
                            $scope.ngModel = null;
                        } else {
                            childScope.ngModel = policy.EmployerId || policy.PolicyId;
                            childScope.selectedData = {
                                id: policy.EmployerId || policy.PolicyId,
                                text: policy.PolicyNumber + ' - ' + (policy.CompanyName || policy.EmployerName || 'N/A'),
                                EmployerId: policy.EmployerId || policy.PolicyId,
                                PolicyNumber: policy.PolicyNumber,
                                EmployerName: policy.CompanyName || policy.EmployerName,
                                StatusCode: policy.StatusCode,
                                Scheme: policy.Scheme
                            };
                        }

                        if (callback) {
                            callback([policy]);
                        }

                        if (!!emitChange) {
                            $scope.$emit('policySelectionChanged', $scope.selectedData);
                        }
                    }; // setSelectedData

                    $scope.fnQuery = function (childScope, key, callback) {
                        policySumm.getPolicySummaryRecently(1, $scope.rowsPerPage, key, $scope.params.jurisdiction, $scope.params.excludeInactivePolicy).then(function (data) {
                            var list = data.PolicyList.map(function (x) {
                                return {
                                    id: x.EmployerId,
                                    text: x.PolicyNumber + ' - ' + x.CompanyName,
                                    EmployerId: x.EmployerId,
                                    CompanyName: x.CompanyName,
                                    PolicyNumber: x.PolicyNumber,
                                    StatusCode: x.StatusCode,
                                    Scheme: x.Scheme
                                };
                            });

                            if (data.PolicyList.length > 0) {
                                list.unshift({
                                    id: 'null',
                                    text: $scope.placeholder
                                });
                            }

                            var result = {
                                results: list,
                                totalItems: data.TotalItems
                            };

                            childScope.currentList = list;
                            childScope.totalItemsFound = result.totalItems;
                            childScope.totalItemsShown = result.totalItems > $scope.rowsPerPage ? $scope.rowsPerPage : result.totalItems;
                            childScope.cacheDataSource[key] = result;
                            callback(result);
                        });
                    }; // fnQuery

                    $scope.fnCurrent = _.debounce(function (childScope, callback) {
                        if (childScope.ngModel) {
                            //only get policy info when another policy is selected
                            if (!childScope.selectedData || childScope.selectedData.id !== childScope.ngModel) {
                                // check if selected policy is in current list policy
                                var policyInfo = childScope.currentList.filter(function (p) {
                                    return p.id === childScope.ngModel;
                                })[0];

                                if (policyInfo) {
                                    childScope.selectedData = {
                                        id: policyInfo.id,
                                        text: policyInfo.text,
                                        EmployerId: policyInfo.EmployerId,
                                        CompanyName: policyInfo.CompanyName,
                                        PolicyNumber: policyInfo.PolicyNumber,
                                        StatusCode: policyInfo.StatusCode,
                                        Scheme: policyInfo.Scheme
                                    };
                                    $scope.setSelectedData(childScope.selectedData, callback, childScope);

                                } else {
                                    policyService.getPolicyDetailForVic(childScope.ngModel).then(function (data) {
                                        childScope.selectedData = {
                                            id: data.EmployerId,
                                            text: data.PolicyNumber + ' - ' + (data.CompanyName || 'N/A'),
                                            EmployerId: data.EmployerId,
                                            CompanyName: data.CompanyName,
                                            PolicyNumber: data.PolicyNumber,
                                            StatusCode: data.StatusCode,
                                            Scheme: data.Scheme
                                        };
                                        $scope.setSelectedData(childScope.selectedData, callback, childScope);
                                    });
                                }
                            } else {
                                $scope.setSelectedData(childScope.selectedData, callback, childScope);
                            }

                        } else {
                            var emitChange = !!childScope.selectedData;
                            callback([{
                                id: 'null',
                                text: $scope.placeholder
                            }]);
                            $scope.setSelectedData(null, null, emitChange, childScope);
                        }
                    }); // fnCurrent

                    var getPolicyFromSessionStorage = function (recentlySelectedType, jurisdiction, useClaimIfAvailable) {
                        var policy = $filter('dec2obj')(sessionStorage.Policy);
                        var claim = $filter('dec2obj')(sessionStorage.Claim);

                        if (recentlySelectedType === commonConst.POLICY && ($scope.ngModel === null || policy.EmployerId === $scope.ngModel) &&
                            !!policy &&
                            (policy.Scheme === jurisdiction || jurisdiction == null)) {
                            return new PolicyModel(policy);

                        }

                        if (recentlySelectedType === commonConst.CLAIM && ($scope.ngModel === null || (claim !== null && claim.PolicyId === $scope.ngModel)) &&
                            !!claim &&
                            (claim.Scheme === jurisdiction || jurisdiction == null) &&
                            !!useClaimIfAvailable) {
                            return new PolicyModel(claim);
                        }

                        return null;
                    }
                }, // controller
                link: function (scope, element, attrs) {
                } // link
            };
        }
    ])